var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58214 5.24611C7.56647 4.83877 7.89247 4.5 8.30012 4.5C8.70777 4.5 9.03375 4.83877 9.01809 5.24612L8.85394 9.51374C8.8425 9.81133 8.59793 10.0467 8.30012 10.0467C8.0023 10.0467 7.75773 9.81133 7.74628 9.51374L7.58214 5.24611ZM9.1 11.6353C9.1 12.0771 8.74182 12.4353 8.3 12.4353C7.85817 12.4353 7.5 12.0771 7.5 11.6353C7.5 11.1935 7.85817 10.8353 8.3 10.8353C8.74182 10.8353 9.1 11.1935 9.1 11.6353Z",
    fill: "#6B7280"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7,
    stroke: "#6B7280",
    strokeWidth: 1.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert_circle.e81733b013f1596eb12867b1b09458d2.svg";
export { ForwardRef as ReactComponent };